import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLocale } from './LocaleProvider';
import { SUPPORTED_LOCALES, type SupportedLocale } from './index';
import { useTranslation } from 'react-i18next';

export const LanguageSwitcher: React.FC<{ className?: string }> = ({ className = '' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentLocale = useLocale();
  const { t } = useTranslation();

  const switchTo = (locale: SupportedLocale) => {
    if (locale === currentLocale) return;

    // Strip current locale prefix from path
    const pathWithoutLocale = location.pathname.replace(/^\/(ru|es)/, '') || '/';

    const newPath = locale === 'en'
      ? pathWithoutLocale
      : `/${locale}${pathWithoutLocale === '/' ? '' : pathWithoutLocale}`;

    navigate(newPath || '/');
  };

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {SUPPORTED_LOCALES.map((locale, i) => (
        <React.Fragment key={locale}>
          {i > 0 && <span className="text-border text-xs">|</span>}
          <button
            onClick={() => switchTo(locale)}
            className={`text-xs font-semibold px-1.5 py-0.5 rounded transition-colors duration-200 ${
              locale === currentLocale
                ? 'text-primary bg-primary/10'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            {t(`language_switcher.${locale}`)}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};
